import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

/** The trail back up: language → book → chapter → section. */
export default function Crumbs({ items }: { items: Crumb[] }) {
  return (
    <nav className="crumbs" aria-label="Breadcrumb">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="crumb">
          {item.to ? (
            <Link to={item.to}>{item.label}</Link>
          ) : (
            <span className="crumb-current">{item.label}</span>
          )}
          {index < items.length - 1 && <span className="crumb-sep" aria-hidden="true">/</span>}
        </span>
      ))}
    </nav>
  );
}
